unit UPersonalizacao_Tabela;

interface

uses
  WEBLib.DBCtrls,
  System.SysUtils,
  System.Classes,
  XData.Web.Client,
  Data.DB,
  XData.Web.Dataset,
  JS,
  WEBLib.StdCtrls,
  System.Generics.Collections,
  WEBLib.Dialogs,
  System.StrUtils,
  UPersonalizacao_Tabela.Interfaces;

type
  TPersonalizacao_Tabela = class(TInterfacedObject, IPersonalizacao_Tabela)
    procedure btnAbrirModalClick(Sender: TObject);

    private
    const
      cCamposObrigatorios : array[0..0] of String = ('nome');

    var
      FCdsPersonalizacao : TXDataWebDataSet;
      FComboTamanhoPagina : TComboBox;
      FColunasTabelaResert : TJsArray;
      FAbrirModalButton : TButton;
      FTabelaIdentificador,
      FColunaPrincipal : string;

      procedure SetColunasModal;
      procedure ConfigurarFuncaoArrastaJs;
      function VerificarPersonalizacaoExiste : Boolean;
      procedure PersonalizarTabela;
      procedure SetPersonalizacaoColunasTabela(pDicionarioColunas : TDictionary<string, TJSObject>);
      function GetDicionarioColunas(pArray : TJSArray) : TDictionary<string, TJSObject>;
      function GetIndexColuna(pTituloField : string): Integer;
      procedure SetColunasResetArray;
      function GetIdentificadorColuna(pIndex : Integer) : string;
      procedure CriarBotoes(pAbrirModalButtonId: string);
      procedure ConfigurarModal;
      function GetArrayColunasModal(var pTamanhoPagina : string) : TJSArray;
      function VerificarColunaExisteArray(pIdentificador : string; pArray : TJSArray) : TJSObject;
      procedure ApagarColunasInexistentes(var pDicionarioColunas : TDictionary<string, TJSObject>);
    public
      FTabela : TDBTableControl;

      constructor Create(pFormularioNome: string; var pTabela : TDBTableControl;
        var pComboTamanhoPagina : TComboBox; pAbrirModalButtonId : string = '');
		  destructor Destroy; override;
      procedure SalvarPersonalizacao(pJson : string);
      procedure RestaurarPersonalizacao;
  end;

implementation

uses
  View.Main,
  UUtils;

{ TPersonalizacao_Tabela }

procedure TPersonalizacao_Tabela.ApagarColunasInexistentes(
  var pDicionarioColunas: TDictionary<string, TJSObject>);
var
  lPair: TPair<string, TJSObject>;
begin
  for lPair in pDicionarioColunas do
  begin
    if VerificarColunaExisteArray(lPair.Key, FColunasTabelaResert) = nil then
      pDicionarioColunas.Remove(lPair.Key);
  end;
end;

procedure TPersonalizacao_Tabela.btnAbrirModalClick(Sender: TObject);
begin
  TUtils.FInstanciaPersonalizacaoTabela := Self;
  ConfigurarModal;
end;


procedure TPersonalizacao_Tabela.ConfigurarFuncaoArrastaJs;
begin
  asm
    const list = document.getElementById('columnsList');
    let draggedItem = null;

    list.querySelectorAll('.column-item').forEach(item => {
        item.addEventListener('dragstart', e => {
            draggedItem = item;
            item.classList.add('dragging');
            e.dataTransfer.effectAllowed = 'move';
        });

        item.addEventListener('dragend', () => {
            draggedItem.classList.remove('dragging');
            draggedItem = null;
        });

        item.addEventListener('dragover', e => {
            e.preventDefault();
            const target = e.currentTarget;
            if (target === draggedItem) return;

            const bounding = target.getBoundingClientRect();
            const offset = e.clientY - bounding.top;

            if (offset > bounding.height / 2) {
                target.after(draggedItem);
            } else {
                target.before(draggedItem);
            }
        });
    });
  end;
end;

procedure TPersonalizacao_Tabela.ConfigurarModal;
begin
  asm
    $('#columnsList').empty();
  end;

  SetColunasModal;
  ConfigurarFuncaoArrastaJs;
  TUtils.OpenModal('modalPersonalizacaoTabela');
end;

constructor TPersonalizacao_Tabela.Create(pFormularioNome : string; var pTabela: TDBTableControl;
  var pComboTamanhoPagina : TComboBox; pAbrirModalButtonId: string);
var
  lBotaoAbrirModal : string;
begin
  FTabela := pTabela;
  FTabelaIdentificador := pFormularioNome + '_' + pTabela.ElementId;
  FCdspersonalizacao := FViewMain.cdsPersonalizacaoTabelas;

  if pAbrirModalButtonId.IsEmpty then
    lBotaoAbrirModal := 'btnPersonalizarTabela'
  else
    lBotaoAbrirModal := pAbrirModalButtonId;

  CriarBotoes(lBotaoAbrirModal);
  FComboTamanhoPagina := pComboTamanhoPagina;
  SetColunasResetArray;
  PersonalizarTabela;
end;

procedure TPersonalizacao_Tabela.CriarBotoes(pAbrirModalButtonId: string);
begin
  FAbrirModalButton := TButton.Create(nil);
  FAbrirModalButton.ElementID := pAbrirModalButtonId;
  FAbrirModalButton.Name := pAbrirModalButtonId;
  FAbrirModalButton.OnClick := btnAbrirModalClick;
end;

destructor TPersonalizacao_Tabela.Destroy;
begin

  inherited;
end;

function TPersonalizacao_Tabela.GetArrayColunasModal(var pTamanhoPagina : string): TJSArray;
var
  lJsonPersonalizacao: TJSObject;
  lArray: TJSArray;
  lColuna: TJSObject;
  lIndice: Integer;
begin
  if not VerificarPersonalizacaoExiste then
  begin
    Result := FColunasTabelaResert;
    pTamanhoPagina := '#size10';
  end
  else
  begin
    Result := TJSArray.new;

    lJsonPersonalizacao := TJSObject(TJSJSON.parse(FCdsPersonalizacao.FieldByName('personalizacao').AsString));
    pTamanhoPagina := '#size' + string(lJsonPersonalizacao['tamanho_pagina']);
    lArray := TJSArray(lJsonPersonalizacao['colunas']);

    for lIndice := 0 to lArray.Length - 1 do
    begin
      lColuna := TJSObject(lArray[lIndice]);

      if VerificarColunaExisteArray(string(lColuna['nome']), FColunasTabelaResert) <> nil then
        Result.push(lColuna);
    end;

    for lIndice := 0 to FColunasTabelaResert.Length - 1 do
    begin
      lColuna := TJSObject(FColunasTabelaResert[lIndice]);

      if VerificarColunaExisteArray(string(lColuna['nome']), Result) = nil then
        Result.push(lColuna);
    end;
  end;
end;

function TPersonalizacao_Tabela.GetDicionarioColunas(
  pArray: TJSArray): TDictionary<string, TJSObject>;
var
  lIndice: Integer;
  lColuna: TJSObject;
begin
  Result := TDictionary<string, TJSObject>.Create;

  for lIndice := 0 to pArray.Length - 1 do
  begin
    lColuna := TJSObject(pArray[lIndice]);
    Result.Add(string(lColuna['nome']), lColuna);
  end;
end;

function TPersonalizacao_Tabela.GetIdentificadorColuna(pIndex: Integer): string;
begin
  Result := FTabela.Columns[pIndex].DataField;
  Result := Result.ToLower;

  if Result.IsEmpty then
    Result := FTabela.Columns[pIndex].Title.ToLower;
end;

function TPersonalizacao_Tabela.GetIndexColuna(pTituloField: string): Integer;
var
  lIndice: Integer;
  lIdentificador : string;
begin
  for lIndice := 0 to FTabela.Columns.Count - 1 do
  begin
    lIdentificador := GetIdentificadorColuna(lIndice);

    if (lIdentificador = pTituloField) then
    begin
      Result := lIndice;
      Exit;
    end;
  end;
end;

function TPersonalizacao_Tabela.VerificarColunaExisteArray(
  pIdentificador: string; pArray : TJSArray): TJSObject;
var
  lColuna : TJSObject;
  lIndice : Integer;
begin
  Result := nil;

  for lIndice := 0 to pArray.Length - 1 do
  begin
    lColuna := TJSObject(pArray[lIndice]);

    if string(lColuna['nome']) = pIdentificador then
    begin
      Result := lColuna;
      Exit;
    end;
  end;
end;

procedure TPersonalizacao_Tabela.PersonalizarTabela;
var
  lJsonPersonalizacao: TJSObject;
  lPageSize: Integer;
  lColunas: TJSArray;
  lDicionarioColunas : TDictionary<string, TJSObject>;
begin
  if not VerificarPersonalizacaoExiste then
  Exit;

  try    
    lJsonPersonalizacao := TJSObject(TJSJSON.parse(FCdsPersonalizacao.FieldByName('personalizacao').AsString));
    lPageSize := Integer(lJsonPersonalizacao['tamanho_pagina']);
    lColunas := TJSArray(lJsonPersonalizacao['colunas']);
    lDicionarioColunas := GetDicionarioColunas(lColunas);
    SetPersonalizacaoColunasTabela(lDicionarioColunas);


    case lPageSize of
      10: FComboTamanhoPagina.ItemIndex := 0;
      25: FComboTamanhoPagina.ItemIndex := 1;
      50: FComboTamanhoPagina.ItemIndex := 2;
      100: FComboTamanhoPagina.ItemIndex := 3; 
    end;
  finally      
    if Assigned(lDicionarioColunas) then
      FreeAndNil(lDicionarioColunas);
  end;
end;

procedure TPersonalizacao_Tabela.RestaurarPersonalizacao;
begin
  if VerificarPersonalizacaoExiste then
  begin
    FCdsPersonalizacao.Delete;
    FCdsPersonalizacao.ApplyUpdates;
  end
  else
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!' +
      slineBreak + '<b>Recarregue a página.</b>');
  end;
end;

procedure TPersonalizacao_Tabela.SalvarPersonalizacao(pJson: string);
begin
  TUtils.ChamarDivLoading;
  
  if VerificarPersonalizacaoExiste then
  begin
    FCdsPersonalizacao.Edit;
    FCdsPersonalizacao.FieldByName('personalizacao').AsString := pJson;
  end
  else
  begin
    FCdsPersonalizacao.Append;
    FCdsPersonalizacao.FieldByName('usuario_id').AsInteger := TUtils.FUsuario.Id;
    FCdsPersonalizacao.FieldByName('tabela_frontend').AsString := FTabelaIdentificador;
    FCdsPersonalizacao.FieldByName('personalizacao').AsString := pJson;
  end;

  FCdsPersonalizacao.Post;
  FCdsPersonalizacao.ApplyUpdates;
end;

procedure TPersonalizacao_Tabela.SetColunasModal;
var
  lIndice : Integer;
  lConteudo,
  lTitle,
  lIdDivCheck,
  lCheck,
  lTamanhoPagina,
  lDisabled : string;
  lArray : TJSArray;
  lColuna: TJSObject;
begin
  lArray := GetArrayColunasModal(lTamanhoPagina);

  asm
    $(lTamanhoPagina).prop('checked', true);
  end;

  for lIndice := 0 to lArray.Length - 1 do
  begin
    lColuna := TJSObject(lArray[lIndice]);

    lIdDivCheck := string(lColuna['nome']);

    lTitle := string(lColuna['titulo']);
    lCheck := EmptyStr;
    lDisabled := EmptyStr;

    if (FColunaPrincipal = lIdDivCheck) or (AnsiIndexStr(lTitle.ToLower, cCamposObrigatorios) >= 0) then
      lDisabled := 'disabled';

    if Boolean(lColuna['visivel']) then
      lCheck := 'checked';

    lConteudo := Format(
    '''
    <div class="column-item" draggable="true" id="%s" data-column="id-instances">
      <div class="drag-handle">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div class="column-content">
        <span class="column-label">%s</span>
        <label class="toggle-switch">
            <input type="checkbox" id="%s" %s %s>
            <span class="toggle-slider"></span>
        </label>
      </div>
      </div>
  ''', [lIdDivCheck, lTitle, 'chk_' + lIdDivCheck, lCheck, lDisabled]);

    asm
      $('#columnsList').append(lConteudo);
    end;
  end;
end;

procedure TPersonalizacao_Tabela.SetColunasResetArray;
var
  lJson : TJSObject;
  lIndice: Integer;
  lIdentificador : string;
begin
  FColunasTabelaResert := TJSArray.new;

  for lIndice := 0 to FTabela.Columns.Count - 1 do
  begin
    lIdentificador := GetIdentificadorColuna(lIndice);

    if lIndice = 0 then
      FColunaPrincipal := lIdentificador;

    lJson := TJSObject.New;
    lJson.Properties['indice'] := lIndice;
    lJson.Properties['nome'] := lIdentificador;
    lJson.Properties['visivel'] := True;
    lJson.Properties['titulo'] := FTabela.Columns[lIndice].Title.ToUpper;

    FColunasTabelaResert.push(lJson);
  end;
end;

procedure TPersonalizacao_Tabela.SetPersonalizacaoColunasTabela(
  pDicionarioColunas : TDictionary<string, TJSObject>);
var
  lIndice,
  lPosicaoColuna : Integer;
  lDadosColuna: TJSObject;
  lPair: TPair<string, TJSObject>;
  lVisivel : Boolean;
  lIdentificador : string;
  lTeste : string;
begin
  ApagarColunasInexistentes(pDicionarioColunas);

  for lIndice := FTabela.Columns.Count - 1 downto 0 do
  begin
    lIdentificador := GetIdentificadorColuna(lIndice);
    if pDicionarioColunas.ContainsKey(lIdentificador) then
    begin
      lDadosColuna := pDicionarioColunas[lIdentificador];

      lVisivel := Boolean(lDadosColuna['visivel']);

      if not lVisivel then
      begin
        FTabela.Columns.Delete(lIndice);
        pDicionarioColunas.Remove(lIdentificador);
      end;
    end;
  end;

  lIndice := 0;

  for lPair in pDicionarioColunas do
  begin
    lPosicaoColuna := GetIndexColuna(lPair.Key);
    FTabela.Columns[lPosicaoColuna].Index := lIndice;

    Inc(lIndice);
  end;
end;

function TPersonalizacao_Tabela.VerificarPersonalizacaoExiste: Boolean;
begin
  Result := FCdsPersonalizacao.Locate('tabela_frontend', FTabelaIdentificador, [loCaseInsensitive]);
end;

end.
